import { render, staticRenderFns } from "./ClientOrderHistoryReport.vue?vue&type=template&id=8fd26a3c&"
import script from "./ClientOrderHistoryReport.vue?vue&type=script&lang=js&"
export * from "./ClientOrderHistoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports